import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ArrowRight, FileUp } from "lucide-react";
import { heroSlides } from "../mock";
import { useShop } from "../context/ShopContext";

const Hero = () => {
  const [idx, setIdx] = useState(0);
  const navigate = useNavigate();
  const { setModal } = useShop();

  useEffect(() => {
    const t = setInterval(() => setIdx((i) => (i + 1) % heroSlides.length), 4500);
    return () => clearInterval(t);
  }, []);

  const slide = heroSlides[idx];

  return (
    <div className="relative rounded-2xl overflow-hidden bg-[#eaf9ef] h-[280px] sm:h-[300px]">
      {heroSlides.map((s, i) => (
        <img
          key={i}
          src={s.img}
          alt=""
          className={`absolute right-0 top-0 h-full w-[55%] sm:w-1/2 object-cover transition-opacity duration-700 ${
            i === idx ? "opacity-100" : "opacity-0"
          }`}
        />
      ))}
      <div className="absolute inset-0 bg-gradient-to-r from-[#eaf9ef] via-[#eaf9ef]/70 to-transparent pointer-events-none" />

      <div key={idx} className="relative h-full flex flex-col justify-center px-6 sm:px-10 max-w-[60%] sm:max-w-[55%] animate-hero-fade">
        <span className="inline-flex w-fit bg-[#12a150] text-white text-[10px] sm:text-[11px] font-bold px-3 py-1 rounded-full mb-3 shadow-sm">
          {slide.badge}
        </span>
        <h1 className="text-[22px] sm:text-[32px] xl:text-[36px] leading-[1.15] font-extrabold text-[#14303f]">
          {slide.titleA}
          <br />
          <span className="text-[#0e7a3d]">{slide.titleB}</span>
        </h1>
        <p className="text-[11px] sm:text-[13px] text-gray-600 mt-2 font-medium">{slide.sub}</p>
        <div className="flex flex-wrap items-center gap-3 mt-4 sm:mt-5">
          <button
            onClick={() => navigate("/category/medicines")}
            className="flex items-center gap-2 bg-[#12a150] hover:bg-[#0d8a40] text-white text-[12px] sm:text-[13.5px] font-semibold rounded-full px-4 sm:px-6 py-2 sm:py-2.5 shadow-md hover:shadow-lg transition-shadow"
          >
            Shop Medicines <ArrowRight size={15} />
          </button>
          <button
            onClick={() => setModal("upload")}
            className="hidden sm:flex items-center gap-2 border-[1.5px] border-[#12a150] text-[#0e7a3d] hover:bg-[#12a150] hover:text-white text-[13.5px] font-semibold rounded-full px-6 py-2 transition-colors"
          >
            <FileUp size={15} /> Upload Prescription
          </button>
        </div>
      </div>

      <div className="absolute bottom-3.5 left-1/2 -translate-x-1/2 flex gap-1.5 z-10">
        {heroSlides.map((_, i) => (
          <button
            key={i}
            onClick={() => setIdx(i)}
            className={`h-2 rounded-full transition-all duration-300 ${
              i === idx ? "w-5 bg-[#12a150]" : "w-2 bg-gray-400/50 hover:bg-gray-400"
            }`}
          />
        ))}
      </div>
    </div>
  );
};

export default Hero;
